import { useSelector } from 'react-redux';

import SwitchInput from 'components/field/SwitchInput';

import * as S from '../../Print.styled';

const ConfigurationOptionList = ({ configOptions, fieldName, isLoading }) => {
	const { planName } = useSelector((state) => state.user);

	return (
		<S.ConfigurationOptionList>
			{configOptions
				.filter((x) => x.type === 'boolean')
				.filter((x) => (x.planName ? x.planName === planName : true))
				.map((item, index) => (
					<S.FormItemSwitch
						key={index}
						direction="row-reverse"
						label={item.name}
						className="col-3 col-xs-12 col-md-12 col-xxl-12"
						{...(item?.toolTip ? { toolTip: item.toolTip } : {})}
						isLoading={isLoading}>
						<SwitchInput name={`${fieldName}.${item.name}`} />
					</S.FormItemSwitch>
				))}
		</S.ConfigurationOptionList>
	);
};

export default ConfigurationOptionList;
